




















import Header from '@/containers/Header.vue'
import Footer from '@/containers/Footer.vue'
import { BOverlay } from 'bootstrap-vue'
export default {
  name: 'MainContainer',
  components: {
    Header,
    Footer,
    BOverlay
  }
}
